import {
  GEOLOCATION_ERROR_CODE,
  getGeolocation,
  isValidGeolocationCoordinates,
  mapGeolocationErrorToI18nKey,
} from '@/shared/lib/geolocation'

export { GEOLOCATION_ERROR_CODE }

export function getCourierGeolocationErrorI18nKey(error) {
  return mapGeolocationErrorToI18nKey(error, {
    permissionKey: 'common.courierLocationRequired',
    unavailableKey: 'common.courierLocationUnavailable',
  })
}

export function isValidCourierCoordinates(lat, lng) {
  return isValidGeolocationCoordinates(lat, lng)
}

export function getCourierGeolocation(options) {
  return getGeolocation(options)
}
